import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'

import * as _ from "../components/index.js";
import { route } from "preact-router";
let timerID;
let nextTimeout;
class Exam extends Component {
  constructor(props) {
    super(props);
    let timer;
    let exam = localStorage.getItem('exam');
    if (!exam) {
      timer = 25 * 60;
      exam = {
        startTime: Date.now(),
        questions: this.getQuestions(20),
        answers: {},
      }
      localStorage.setItem('exam', JSON.stringify(exam));
      localStorage.setItem('timer', timer);
    } else {
      exam = JSON.parse(exam);
      timer = localStorage.getItem('timer');
    }

    let questions = exam.questions;
    let answers = exam.answers;
    this.state = {
      questionsTotal: questions ? Object.keys(questions).length : 0,
      questions: questions ? questions : {},
      answers: answers,
      favs: this.getFavs(),
      activeQuestion: 0,
      lang: props.app.lang,
      templates: Globals.Templates(),
      timer: timer,
      timerTxt: '-:--',
      timeOut: false,
      scrollLeftPosition: 0
    };

    this.setState({
      activeQuestion: this.findFirstQuestion()
    })

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // const scrollContainer = this.scrollRef;
    // if (scrollContainer) {
    //   scrollContainer.scrollTo({ left: this.state.scrollLeftPosition });
    // }
  }

  componentDidMount() {

    timerID = setInterval(() => {
      if (this.state.timer < 1) {
        clearInterval(timerID);
        localStorage.setItem('timer', 0);
        this.openResultModal();
      } else {
        let newTimer = this.state.timer - 1;
        this.setState({
          timer: newTimer,
          timerTxt: this.fancyTimeFormat(newTimer),
        })
        localStorage.setItem('timer', newTimer);
      }
    }, 1000);
  }

  openResultModal = () => {
    this.setState({
      timeOut: true
    })
    let el = $('.readyBtn')[0];
    el.click()
  }

  getQuestions = (qNum) => {
    let questions = [];

    let templates = Globals.Templates();
    let randTemplate, randQuestion, question;
    for (let i = 0; i < qNum; i++) {
      randTemplate = Math.floor(Math.random() * 100);
      randQuestion = Math.floor(Math.random() * 10);
      question = templates[randTemplate].questions[randQuestion]
      question.templateId = randTemplate;
      question.ord = (i + 1);
      questions[i] = question;
    }

    return questions;
  }

  getFavs = () => {
    let favs = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[i] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(id);
        })
        favs = { ...favs, ...tmp }
      }
    })
    return favs;
  }

  findFirstQuestion() {
    let questions = this.state.questions;
    let questionNum = 0;
    let finded = false;

    {
      Object.keys(questions).map((tmp) => {
        if (!finded) {
          let question = questions[tmp];
          if (this.state.answers && !this.state.answers[question.id]) {
            questionNum = tmp;
            finded = true;
          }
        }
      })
    }
    return questionNum;
  }

  fancyTimeFormat(duration) {
    const hrs = ~~(duration / 3600);
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;

    let ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;

    return ret;
  }

  setActiveQuestion = (e) => {
    clearTimeout(nextTimeout);
    let rel = parseInt($(e.target).attr('rel'));
    this.setState({
      activeQuestion: rel
    })
    this.centerActiveItem(rel);
  }

  setAnswer = (e) => {

    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let answerId = parseInt(t.val());
    let templateId = parseInt(t.val());

    let examData = localStorage.getItem('exam') ? localStorage.getItem('exam') : '{}';
    let exam = JSON.parse(examData ? examData : '{}');

    if (!exam) {
      exam = {}
    }

    if (!exam.answers) {
      exam.answers = {}
    }

    let isAnswered = exam.answers[questionId] ? true : false;

    if (isAnswered) {
      e.preventDefault();
      return false;
    }

    exam.answers[questionId] = answerId;

    let isCorrect = false;
    console.log(this.state.questions);
    let idx = this.state.questions.findIndex(x => x.id == questionId);
    let idxA = this.state.questions[idx].answers.findIndex(x => x.id == answerId);

    if (this.state.questions[idx].answers[idxA].isCorrect) {
      isCorrect = true;
    }

    localStorage.setItem('exam', JSON.stringify(exam));

    this.setState({
      answers: exam.answers,
    })

    nextTimeout = setTimeout(this.nextQuestion, 3000);
    // if (isCorrect && this.state.activeQuestion != (Object.keys(this.state.questions).length - 1)) {
    // }
  }

  nextQuestion = () => {
    clearTimeout(nextTimeout);
    let nextQuestion = parseInt(this.state.activeQuestion) + 1;
    if (nextQuestion > (Object.keys(this.state.questions).length - 1)) {
      nextQuestion = (Object.keys(this.state.questions).length - 1);
    }
    if (this.state.activeQuestion == (Object.keys(this.state.questions).length - 1)) {
      nextQuestion = this.findFirstQuestion();
    }
    this.setState({
      activeQuestion: nextQuestion
    })
    this.centerActiveItem(nextQuestion);
  }

  /*  centerActiveItem = (act) => {
     if(typeof act == 'undefined'){
       act = this.state.activeQuestion;
     }
     let scrollPosition
     if(act > (Object.keys(this.state.questions).length / 2)){
       scrollPosition = (act) * 40
     } else {
       scrollPosition = (act - 2) * 40
     }
     
     this.setState((state) => {
       return {
         ...state,
         scrollLeftPosition: scrollPosition
       };
     });
   } */
  centerActiveItem = (act) => {
    if (typeof act == 'undefined') {
      act = this.state.activeQuestion;
    }
    let scrollPosition
    if (act > (Object.keys(this.state.questions).length / 2)) {
      scrollPosition = (act + 2) * 44
    } else {
      scrollPosition = (act - 2) * 44
    }

    const scrollContainer = this.scrollRef;
    if (scrollContainer) {
      scrollContainer.scrollTo(scrollPosition, 0);
    }
  }
  exit = () => {
    localStorage.removeItem('exam');
    localStorage.removeItem('timer');
    route('/');
  }

  showErrorModal = () => {

  }

  complete = () => {

  }

  addFav = (e) => {

    let t = $(e.target);
    let templateId = parseInt(t.attr('data-template'));
    let questionId = parseInt(t.attr('rel'));

    let data = JSON.parse(localStorage.getItem('favs_' + templateId))

    if (!data) {
      data = {}
    }
    data[questionId] = 1

    this.setState({
      favs: data
    })

    localStorage.setItem('favs_' + templateId, JSON.stringify(data));
    $('#add_favorite_item').parent().find('.btn-secondary').click();
  }

  delFav = (e) => {
    let t = $(e.target);
    let templateId = parseInt(t.attr('data-template'));
    let questionId = parseInt(t.attr('rel'));
    let data = JSON.parse(localStorage.getItem('favs_' + templateId))
    if (data) {
      if (data[questionId]) {
        delete data[questionId];
        this.setState({
          favs: data
        })
      }
    }
    localStorage.setItem('favs_' + templateId, JSON.stringify(data));
    $('#del_favorite_item').parent().find('.btn-secondary').click();
  }

  restart = () => {
    localStorage.removeItem('exam');
    localStorage.removeItem('timer');

    window.location.reload();
  }

  render() {
    let lang = this.state.lang
    let questions = this.state.questions ? this.state.questions : {};
    let favs = this.state.favs ? this.state.favs : {};
    let questionsTotal = this.state.questionsTotal;
    let activeQuestion = this.state.activeQuestion;
    let data = this.state.questions ? this.state.questions[activeQuestion] : {};

    if (!data) {
      return <>
        <section class="header">
          <div class="header_menu">
            <div class="d-flex align-items-center">
              <a href="/" class="mx-2" type="button"><i class="demo-icon icon-angle-left"></i></a>
              <span class="ms-2">Ошибка</span>
            </div>
          </div>
        </section>
      </>
    }

    let image = data ? data.image : null;
    let answers = data ? data.answers : null;

    let qClass = '';
    let correctAnswer = '';
    let displayExp = 'd-none';
    let ansLength = this.state.answers ? Object.keys(this.state.answers).length : 0
    let exp = this.state.usedExp ? this.state.usedExp : {}
    let expLength = this.state.usedExp ? Object.keys(this.state.usedExp).length : 0

    let displayNextQuestion = (ansLength + expLength != questionsTotal ? '' : 'd-none');
    let displayComplete = (ansLength + expLength == questionsTotal ? '' : 'd-none');

    let isFav = favs[data.id] ? true : false;

    let counters = {
      correct: 0,
      exp: 0,
    }
    return (
      <>

        <section class="header">

          <div class="header_menu">
            <div class="d-flex align-items-center">
              <a href="#" class="mx-2" type="button" data-bs-toggle="modal" data-bs-target="#back"><i class="demo-icon icon-angle-left"></i></a>
              <span class="ms-2">Экзамен!</span>
            </div>
            <div class="d-flex align-items-center">
              <span class="time"><i class="demo-icon icon-clock-1 me-1"></i>{this.state.timerTxt}</span>
              {!isFav ?
                <a href="#" class="mx-2" type="button" data-bs-toggle="modal" data-bs-target="#add_favorite_item">
                  <i class="demo-icon icon-heart-empty-1 red_icon"></i>
                </a>
                :
                <a href="#" class="mx-2" data-bs-toggle="modal" data-bs-target="#del_favorite_item">
                  <i class="demo-icon icon-heart-1 red_icon"></i>
                </a>
              }

            </div>
          </div>

          <div class="options" ref={(ref) => (this.scrollRef = ref)}>
            {Object.keys(questions).map((tmp) => {

              { qClass = '' }

              {
                if (exp[questions[tmp].id]) {
                  qClass = 'option_orange';
                } else {
                  if (this.state.answers && this.state.answers[questions[tmp].id]) {
                    if (questions[tmp].correctId == this.state.answers[questions[tmp].id]) {
                      counters.correct++;
                      qClass = 'option_green';
                    } else {
                      qClass = 'option_red';
                    }
                  }
                }

                if (activeQuestion == tmp) {
                  qClass += ' option_active';
                }
              }

              return <a href="javascript:void(0)" onClick={this.setActiveQuestion} rel={tmp} class={`option ${qClass}`}>{questions[tmp].ord}</a>
            })}
          </div>

        </section>

        <section class="menu menu_test">

          <div class="quest">
            {(image ? <img src={image} alt="" class="quest_img" /> : null)}
            <span class="font_bold">Вопрос:</span>
            <span class="" dangerouslySetInnerHTML={{
              __html: data.question[lang]
            }}></span>
          </div>

          <div class="my-2">
            {Object.keys(answers).map((tmp) => {
              var isChecked = false;
              var isCorrect = false;
              var className = 'false';

              if (answers[tmp]['isCorrect']) {
                correctAnswer = answers[tmp][lang]
                exp = answers[tmp]['exp'][lang]
                isCorrect = true;
                className = 'true';
              }

              if (this.state.answers && this.state.answers[data.id]) {

                if (isCorrect && this.state.answers[data.id] != answers[tmp]['id']) {
                  className = 'bg-success';
                } else {
                  displayExp = '';
                }
              }

              if (this.state.answers && this.state.answers[data.id] == answers[tmp]['id']) {
                isChecked = true;
              } else {
                if (isCorrect) {
                  if (this.state.usedExp && this.state.usedExp[data.id]) {
                    className = 'bg-success';
                    displayExp = '';
                  }
                }
              }

              return <span>
                <input type="radio" class={className} id={`answer_${answers[tmp]['id']}`} rel={data.id} name={`answer`} value={answers[tmp]['id']} data-isCorrect={answers[tmp]['isCorrect']} onClick={this.setAnswer} data-template={data.templateId} checked={isChecked} />
                <label for={`answer_${answers[tmp]['id']}`} dangerouslySetInnerHTML={{
                  __html: answers[tmp][lang]
                }}></label>
              </span>
            })}
          </div>

          <div class={`d-flex flex-column questionExp ${displayExp}`}>
            <span class="font_bold">Правильный ответ:</span>
            <span class="mt-1">{correctAnswer}</span>

            <a class={`btn btn-info mt-3 ${displayNextQuestion}`} href="javascript:void(0)" onClick={this.nextQuestion} role="button">Следующий вопрос</a>
            <a class={`btn btn-info mt-3 readyBtn ${displayComplete}`} href="javascript:void(0)" onClick={this.complete} data-bs-toggle="modal" data-bs-target="#finish">Готово</a>

            <a class="btn btn-light mt-3" onClick={this.showErrorModal} href="javascript:void(0)" role="button">Сообщить об ошибке</a>
          </div>


        </section>

        <div class="modal fade" id="add_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Добавить в избранное?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-success mx-3" rel={data.id} data-template={data.templateId} onClick={this.addFav}>Добавить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="del_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Удалить вопрос из избранного?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-danger mx-3" rel={data.id} data-template={data.templateId} onClick={this.delFav}>Удалить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="back" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20 text-center">Хотите выйти и завершить экзамен?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <a href="#" onClick={this.exit} class="btn btn-danger ms-3" data-bs-dismiss="modal">Выход</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="finish" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  {(this.state.timeOut ? <span class="mb-3 font20 text-danger">Время истекло!</span> : null)}
                  <div class="mb-3 font20">Результат:
                    {(questionsTotal - counters.correct) > 2
                      ? <b class="text-danger">Не сдан</b>
                      : <b class="text-success">Экзамен сдан</b>}
                  </div>
                  <div class="mb-1">Правильный <span class="text-success">{counters.correct}</span> \ {questionsTotal}</div>
                  <div class="mb-1">Неправильный <span class="text-danger">{questionsTotal - counters.correct}</span> \ {questionsTotal}</div>
                  <div class="mt-3">
                    <button type="button" class="btn btn-primary" onClick={this.restart}>Ещё раз</button>
                    <button type="button" class="btn btn-success mx-2" data-bs-dismiss="modal">ОК</button>
                    <a href="/" type="button" class="btn btn-info mx-2" data-bs-dismiss="modal">Назад</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default GlobState.connect(Exam, Globals)